import { Button } from '@99designs/common/components/Button';
import React from 'react';

interface Props {
    userId: number;
    designId: number;
}

const DesignEditButton = ({ designId }: Props) => (
    <Button variations={['secondary', 'fluid']} href={`/account/portfolio/edit/${designId}`}>
        {__('Edit design')}
    </Button>
);

export default DesignEditButton;



// WEBPACK FOOTER //
// ./src/js/components/DesignEditButton.tsx